<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <v-icon style="cursor: pointer; user-select: none; float: right" @click="$emit('closeModal')">
        close
      </v-icon>
      <div class="coupon-info-container">
        <div class="coupon-info-container__data">
          <h2>{{ prepaidCouponUser.name }} ({{ prepaidCouponUser.qrcode }})</h2>
          <div>
            <h3 style="color: #666">{{ prepaidCouponUser.prepaidCoupon.name }}</h3>
          </div>
        </div>
        <div class="qrcode-and-text-container">
          <div class="qrcode-container">
            <canvas ref="qrcode" style="height: 100%; width: 100%" />
          </div>
          <main-button color="#f5f5f5" @click="downloadQrCode">
            <span style="color: #0277bd">DOWNLOAD QR CODE</span>
          </main-button>
        </div>
      </div>
      <div class="subscriber-info-container">
        <div>
          <h3 style="color: #0277bd">Podaci o članu</h3>
          <table class="subscriber-info-container__table text_small">
            <tr
              v-for="fieldName in sortedAttendeeFieldNames()"
              :key="fieldName"
            >
              <td>{{ fieldName }}:</td>
              <td v-if="fieldName === 'Email'">{{ prepaidCouponUser.fields[fieldName] || prepaidCouponUser.email || '' }}</td>
              <td v-else>{{ prepaidCouponUser.fields[fieldName] || '' }}</td>
            </tr>
          </table>
        </div>
        <main-button color="#f5f5f5" @click="onEditDataClick">
          <span style="color: #0277bd">UREDI PODATKE</span>
        </main-button>
      </div>
      <div class="all-tickets-container" style="margin-top: 2rem; margin-bottom: -0.5rem">
        <h3 style="color: #0277bd">Svi događaji /utakmice</h3>
        <div class="tickets-numbers-icon-container">
          <span
            class="tickets-numbers-text"
          >{{ calculateTotalScannedTickets() }}/{{ calculateTotalTickets() }}</span>
          <img
            src="/assets/ticket-outlined.svg"
            alt="ticket icon"
            style="width: 1.5rem; height: 1.5rem"
          >
        </div>
      </div>
      <div
        v-for="[monthAndYear, accreditations] in Object.entries(groupedScannedAccreditations)"
        :key="monthAndYear"
      >
        <div class="monthly-tickets-container" style="margin-top: 1rem">
          <h3 style="color: #666">{{ monthAndYear }}</h3>
          <div class="tickets-numbers-icon-container">
            <span
              class="tickets-numbers-text"
            >{{ calculateTotalScannedTicketsInMonth(monthAndYear) }}/{{
              calculateTotalTicketsInMonth(monthAndYear)
            }}</span>
            <img
              src="/assets/ticket-outlined.svg"
              alt="ticket icon"
              style="width: 1.5rem; height: 1.5rem"
            >
          </div>
        </div>
        <div style="margin-top: 0.5rem">
          <div
            v-for="accreditation in accreditations.filter(a => !!a.scanEventEntry)"
            :key="accreditation.id"
            class="scanned-ticket-container"
          >
            <span
              class="usage-text"
            >Used on {{ formatDate(accreditation.scanEventEntry.createdAt) }}</span>
            <span class="usage-text" style="font-weight: 700">{{ accreditation.event.title }}</span>
          </div>
        </div>
      </div>
      <div class="additional-items-title-container">
        <h3 style="color: #0277bd; flex: 1">Fizička kartica</h3>
        <div class="body__small">
          Aktivacija:
          {{ physicalCardActivationDate }}
        </div>
        <div class="tickets-numbers-icon-container">
          <span class="tickets-numbers-text">{{ flags.physicalCardSent ? '1' : '0' }}/1</span>
          <img
            src="/assets/ticket-outlined.svg"
            alt="ticket icon"
            style="width: 1.5rem; height: 1.5rem"
          >
        </div>
      </div>
      <div class="send-status-container">
        <div class="send-status-container_data">
          <div class="body__small">Status:</div>
          <v-radio-group v-model="flags.physicalCardSent" class="radio-group-container">
            <v-radio :value="true">
              <template #label>
                <span
                  class="custom-radio-label"
                  :style="flags.physicalCardSent && 'color: #666'"
                >Poslano</span>
              </template>
            </v-radio>
            <v-radio :value="false">
              <template #label>
                <span
                  class="custom-radio-label"
                  :style="flags.physicalCardSent === false && 'color: #666'"
                >Nije poslano</span>
              </template>
            </v-radio>
          </v-radio-group>
        </div>
        <img
          :src="getSuccessIconSrc(flags.physicalCardSent)"
          alt="success icon"
          style="width: 1.5rem; height: 1.5rem"
        >
      </div>
      <div class="additional-items-title-container" style="margin-top: -1rem">
        <h3 style="color: #0277bd; flex: 1">Poklon vjernosti</h3>
        <div class="body__small">Majica/Dres</div>
        <div class="tickets-numbers-icon-container">
          <!--          <span class="tickets-numbers-text">L</span>-->
          <img src="/assets/t-shirt.svg" alt="t-shirt icon" style="width: 1.5rem; height: 1.5rem">
        </div>
      </div>
      <div class="send-status-container">
        <div class="send-status-container_data">
          <div class="body__small">Status:</div>
          <v-radio-group v-model="flags.loyaltyGiftSent" class="radio-group-container">
            <v-radio :value="true">
              <template #label>
                <span
                  class="custom-radio-label"
                  :style="flags.loyaltyGiftSent && 'color: #666'"
                >Poslano</span>
              </template>
            </v-radio>
            <v-radio :value="false">
              <template #label>
                <span
                  class="custom-radio-label"
                  :style="flags.loyaltyGiftSent === false && 'color: #666'"
                >Nije poslano</span>
              </template>
            </v-radio>
          </v-radio-group>
        </div>
        <img
          :src="getSuccessIconSrc(flags.loyaltyGiftSent)"
          alt="success icon"
          style="width: 1.5rem; height: 1.5rem"
        >
      </div>
      <div class="divider" />
    </div>
    <simple-snackbar
      :open.sync="snackbarOpen"
      :message-prop="snackbarMessage"
      :color="snackbarColor"
    />
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { croatianMonths } from '@/utils'
import moment from 'moment'
import { omit, mapValues } from 'lodash'
import { UPDATE_PREPAID_COUPON_USER_FLAGS } from '@/graphql/prepaidCouponUser.graphql'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'
import { sportOrganizationRouteNames } from '@/routing/routeNames/sportOrganizerRouteNames'

export default {
  name: 'sport-subscription-details-modal',
  components: { SimpleSnackbar },
  props: {
    prepaidCouponUser: Object,
    organizationSlug: String,
  },
  data() {
    return {
      groupedScannedAccreditations: {},
      flags: this.getFlagsValue(),
      snackbarOpen: false,
      snackbarMessage: '',
      snackbarColor: 'error',
    }
  },
  computed: {
    physicalCardActivationDate() {
      return this.prepaidCouponUser.flags.physicalCardSent
        ? this.formatDate(this.prepaidCouponUser.flags.physicalCardSent)
        : '-'
    },
  },
  watch: {
    flags: {
      async handler() {
        const { errors } = await this.$apollo.mutate({
          mutation: UPDATE_PREPAID_COUPON_USER_FLAGS,
          variables: {
            organizationSlug: this.organizationSlug,
            prepaidCouponUserId: this.prepaidCouponUser.id,
            flags: this.flags,
          },
        })
        if (errors) {
          this.snackbarOpen = true
          this.snackbarMessage = 'Something went wrong.'
          Object.assign(this.flags, this.getFlagsValue())

          return
        }
        this.$emit('refetch')
      },
      deep: true,
    },
  },
  async mounted() {
    await this.generateQrCode(this.prepaidCouponUser.qrcode)
    this.groupedScannedAccreditations = this.groupAndSortScannedAccreditations(
      this.prepaidCouponUser.accreditations,
    )
  },
  methods: {
    omit,
    async generateQrCode(value) {
      const canvas = this.$refs.qrcode

      return QRCode.toCanvas(canvas, value, {
        width: 126,
        margin: 0,
      })
    },
    downloadQrCode() {
      const canvas = this.$refs.qrcode
      const link = document.createElement('a')
      link.href = canvas.toDataURL('image/png')
      link.download = `subscription-${this.prepaidCouponUser.code}.png`
      link.click()
    },
    groupAndSortScannedAccreditations(accreditations) {
      const groupedAccreditations = {}

      for (const accreditation of accreditations) {
        const eventDate = new Date(accreditation.event.from)
        const monthAndYear = `${croatianMonths[eventDate.getMonth()]} ${eventDate.getFullYear()}.`

        if (!groupedAccreditations[monthAndYear]) {
          groupedAccreditations[monthAndYear] = [accreditation]
        } else {
          groupedAccreditations[monthAndYear].push(accreditation)
        }
      }

      for (const group of Object.values(groupedAccreditations)) {
        group.sort((a, b) => {
          const dateA = a.scanEventEntry ? new Date(a.scanEventEntry.createdAt) : null
          const dateB = b.scanEventEntry ? new Date(b.scanEventEntry.createdAt) : null
          if (!dateA) return 1
          if (!dateB) return -1

          return dateA - dateB
        })
      }

      return groupedAccreditations
    },
    calculateTotalTickets() {
      return this.prepaidCouponUser.accreditations.length
    },
    calculateTotalScannedTickets() {
      return this.prepaidCouponUser.accreditations.reduce(
        (acc, curr) => acc + (curr.scanEventEntry ? 1 : 0),
        0,
      )
    },
    calculateTotalTicketsInMonth(monthAndYear) {
      return this.groupedScannedAccreditations[monthAndYear].length
    },
    calculateTotalScannedTicketsInMonth(monthAndYear) {
      return this.groupedScannedAccreditations[monthAndYear].reduce(
        (acc, curr) => acc + (curr.scanEventEntry ? 1 : 0),
        0,
      )
    },
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY.')
    },
    getFlagsValue() {
      return mapValues(this.prepaidCouponUser.flags, value => !!value)
    },
    getSuccessIconSrc(flag) {
      return `/assets/${flag === undefined ? 'questionmark' : flag ? 'success' : 'error'}-icon.svg`
    },
    sortedAttendeeFieldNames() {
      const attendeeFields = this.prepaidCouponUser.prepaidCoupon.organization.attendeeFields.subscriptionFields

      return Object.keys(attendeeFields).sort((a, b) => {
        return attendeeFields[a].order - attendeeFields[b].order
      })
    },
    onEditDataClick() {
      this.goTo(
        this.routes.sportOrganization.sportOrganizationSubscriptionUpdate,
        {
          id: this.prepaidCouponUser.id,
        }
      )
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  max-height: 100%;
  position: relative;
  max-width: 40.75rem;
  padding: 1.5rem 1.5rem 3.25rem 1.5rem;
  border-radius: 0.75rem;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}

.coupon-info-container {
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
}

.coupon-info-container__data {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
}

h2 {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}

h3 {
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}

.text__small {
  margin: 0;
  color: #666;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.qrcode-container {
  height: fit-content;
  width: fit-content;
  padding: 1.25rem;
  border-radius: 0.625rem;
  border: 1px solid rgba(151, 151, 151, 0.5);
  background: #fff;
}

.subscriber-info-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-self: stretch;
  margin-top: 2rem;
  padding-top: 0.75rem;
  border-top: 1px solid #d9d9d9;
}

.qrcode-and-text-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  align-self: stretch;
  gap: 1rem;
}

@media screen and (max-width: 550px) {
  .subscriber-info-container {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .coupon-info-container {
    flex-direction: column;
    gap: 0.5rem;
  }

  .qrcode-and-text-container {
    align-items: flex-start;
  }
}

.subscriber-info-container__table {
  margin-top: 1.25rem;
}

.all-tickets-container,
.monthly-tickets-container {
  border-top: 1px solid #d9d9d9;
  padding-top: 0.75rem;
  display: flex;
  justify-content: space-between;
  gap: 2.5rem;
}

.tickets-numbers-icon-container {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.tickets-numbers-text {
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}

.scanned-ticket-container {
  display: flex;
  gap: 0.5rem;
}

.usage-text {
  color: #979797;
  text-align: right;
  font-family: 'Source Sans Pro';
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.additional-items-title-container {
  display: flex;
  gap: 2.5rem;
  border-top: 1px solid #d9d9d9;
  padding-top: 0.75rem;
  margin-top: 1rem;
  justify-content: space-between;
}

.body__small {
  color: #666;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.send-status-container {
  display: flex;
  margin-top: 0.62rem;
}

.send-status-container_data {
  display: flex;
  gap: 0.75rem;
  flex: 1;
}

::v-deep .v-input--radio-group__input {
  display: flex;
  flex-direction: row;
  margin-top: 0 !important;
  padding-top: 0 !important;
}

::v-deep .radio-group-container {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.divider {
  border-top: 1px solid #d9d9d9;
  margin-top: -1rem;
}

.custom-radio-label {
  color: #979797;
  font-family: 'Source Sans Pro';
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

button {
  margin: 0;
}
</style>
